import styled, { css } from 'styled-components';
import { rootStyle } from "../../styles";
export var List = styled.ul.withConfig({
  displayName: "List",
  componentId: "sc-1t3o2fv-0"
})(["", ";padding-left:0;margin-top:0;margin-bottom:0;padding-bottom:0;", ";"], rootStyle(), function (props) {
  return props.listStyleReset !== false && css(["list-style-type:none;"]);
});
export default List;